//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Curve.js";
import "../no/ugmath.js";
let d=[[[0,"Order",0,0],[0,"Periodic",0,0],[0,"PoleCount",0,0],[0,"Rational",0,0]],[[["numKnots"],"GetKnots",{R_:{knots:""}},0,0],[["numPoles"],"GetPoles",{R_:{poles:""}},0,0],[["numPoles"],"Get3DPoles",{R_:{poles:""}},0,0],[["numPoints"],"GetDefiningPoints",{R_:{points:""}},0,0]],[]];
SPLM.Spline = class extends SPLM.Curve{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Spline";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;